var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('JobEditor',{staticClass:"job-template-editor",attrs:{"is-template":"","is-edit-mode":_vm.isEditMode,"value":_vm.jobTemplateInfo},on:{"cancel":_vm.handleCancel,"save":_vm.handleSave,"save-back":_vm.handleSaveAndBack}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }